import { Entity, Field } from '@adornis/baseql/decorators.js';
import { Price } from '@adornis/payments/db/prices.js';
import { validate } from '@adornis/validation/decorators.js';
import { nonOptional } from '@adornis/validation/functions/nonOptional.js';

@Entity()
export class BundlePrice extends Price {
  static override _class = 'BundlePrice';

  @validate(nonOptional())
  @Field(type => String)
  bundleID!: string;
}
